import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

import './main.css';

const progress = <CircularProgress size={40} styleName="progress" />;

export default progress;
